import { FC } from 'react';

import style from './v-saparator.less';

const VSeparator: FC = () => {
    return <div className={style.vSeparator} />;
};

export default VSeparator;
